
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.293 8.79a1.218 1.218 0 010-1.584l4-4.478a.928.928 0 011.416 0c.39.437.39 1.147 0 1.585L3.415 6.88H15c.553 0 1 .5 1 1.12 0 .62-.447 1.12-1 1.12H3.415l2.294 2.567c.39.438.39 1.148 0 1.585a.928.928 0 01-1.416 0l-4-4.478v-.003z","fill":"#313131"}})])
          )
        }
      }
    